(function() {

	'use strict';

	angular.module('FYN').controller('TourController', function($scope) {
        
    });

})();
